<!-- Historial de acceso: quién entra a la plataforma y cuándo. -->

<app-page-title [title]="pageLabel()" backRoute="/audit/menu" backTooltip="Regresar al menú de auditoría"></app-page-title>
<app-page-loader [load]="pageLoad" [label]="pageLabel()" (retry)="init()"></app-page-loader>

<!-- Indicadores del rango filtrado -->
<div class="kpis">
  <div class="kpi"><mat-icon>login</mat-icon><div><div class="kpi__value">{{ kpis.total }}</div><div class="kpi__label">Accesos</div></div></div>
  <div class="kpi"><mat-icon>group</mat-icon><div><div class="kpi__value">{{ kpis.users }}</div><div class="kpi__label">Usuarios distintos</div></div></div>
  <div class="kpi"><mat-icon>schedule</mat-icon><div><div class="kpi__value kpi__value--sm">{{ kpis.last }}</div><div class="kpi__label">Último acceso</div></div></div>
  <div class="kpi"><mat-icon>language</mat-icon><div><div class="kpi__value kpi__value--sm">{{ kpis.topBrowser }}</div><div class="kpi__label">Navegador más usado</div></div></div>
</div>

<!-- Filtros -->
<div class="filter-bar filter-bar--flush">
  <div class="filter-card">
    <app-search-pill [value]="userFilter" placeholder="Usuario, correo o rol…" (valueChange)="userFilter = $event; applyFilters()"></app-search-pill>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Periodo</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate" placeholder="Inicio" (dateChange)="applyFilters()">
        <input matEndDate [(ngModel)]="endDate" placeholder="Fin" (dateChange)="applyFilters()">
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
    <span class="filter-card__meta"><b>{{ dataSource.data.length }}</b> registro(s)</span>
    <mat-button-toggle-group class="view-toggle" [value]="listView.mode" (change)="listView.set($event.value)" [hideSingleSelectionIndicator]="true" aria-label="Vista">
      <mat-button-toggle value="table" matTooltip="Vista de tabla"><mat-icon>table_rows</mat-icon></mat-button-toggle>
      <mat-button-toggle value="cards" matTooltip="Vista de tarjetas"><mat-icon>grid_view</mat-icon></mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <app-filter-chips [chips]="filterChips" [count]="dataSource.data.length" [total]="allLogs.length" noun="accesos" (remove)="removeChip($event)" (clear)="clearFilters()"></app-filter-chips>
</div>

<div class="list-actions">
  <button mat-stroked-button (click)="pageLoad.refresh(load())" [disabled]="loading()"><mat-icon>refresh</mat-icon> Actualizar</button>
  <button mat-flat-button color="primary" (click)="downloadExcel()"><mat-icon>download</mat-icon>Descargar Excel</button>
</div>

@if (loading()) {
  <div class="loading-row"><mat-spinner diameter="32"></mat-spinner><span>Cargando accesos...</span></div>
}

@if (listView.mode === 'cards') {
  <div class="inv-cards cat-cards">
    @for (log of dataSource.data; track $index) {
      <div class="cat-card">
        <div class="cat-card__head">
          <mat-icon class="card-icon">login</mat-icon>
          <span class="cat-card__title">{{ log.name || '—' }}</span>
          @if (log.roleName) { <span class="role-chip">{{ log.roleName }}</span> }
        </div>
        <div class="cat-card__body">
          <div class="cat-card__field"><span class="cat-card__label">Correo:</span><span class="cat-card__value">{{ log.email || '—' }}</span></div>
          <div class="cat-card__field"><span class="cat-card__label">Fecha:</span><span class="cat-card__value">{{ datePart(log.createdOn) }} · {{ timePart(log.createdOn) }}</span></div>
          <div class="cat-card__field"><span class="cat-card__label">Navegador:</span><span class="cat-card__value">{{ browserOf(log.userAgent) }}</span></div>
        </div>
      </div>
    }
    @if (dataSource.data.length === 0) {
      <p class="inv-cards__empty">Sin accesos registrados en el rango</p>
    }
  </div>
}

<div class="table-container" [hidden]="listView.mode !== 'table'">
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef>Fecha y hora</th>
      <td mat-cell *matCellDef="let log"><div class="dt"><span>{{ datePart(log.createdOn) }}</span><small>{{ timePart(log.createdOn) }}</small></div></td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Usuario</th>
      <td mat-cell *matCellDef="let log">
        <div class="user-cell"><b>{{ log.name || '—' }}</b><small>{{ log.email || '' }}</small></div>
      </td>
    </ng-container>
    <ng-container matColumnDef="roleName">
      <th mat-header-cell *matHeaderCellDef>Rol</th>
      <td mat-cell *matCellDef="let log">@if (log.roleName) { <span class="role-chip">{{ log.roleName }}</span> } @else { — }</td>
    </ng-container>
    <ng-container matColumnDef="userAgent">
      <th mat-header-cell *matHeaderCellDef class="hide-mobile">Navegador</th>
      <td mat-cell *matCellDef="let log" class="hide-mobile">{{ browserOf(log.userAgent) }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    <tr class="no-data-row" *matNoDataRow>
      <td [attr.colspan]="columns.length">
        <div class="no-data"><mat-icon>inbox</mat-icon><span>Sin accesos registrados en el rango — los registros se crean a partir de ahora, con cada inicio de sesión</span></div>
      </td>
    </tr>
  </table>
</div>
